import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useEffect } from "react";
import {
  formatSessionNameForURL,
  isWindowInIframe,
  replaceDashesWithSpaces,
} from "../../v2_actions/nav";

import DesktopEventList from "./DesktopEventList";
import DesktopEventPageFilter from "./DesktopEventPageFilter";
import { EventPageBreadCrumbs } from "./EventPageBreadcrumbs";
import { EventsLayout } from "../layout/EventsLayout";
import LoadingSpinner from "../../views/components/LoadingSpinner";
import MobileEventList from "../MobileEventList";
import ReactGA from "react-ga4";
import SubEventFilter from "../SubEventFilter";
import { setGalleryNavBackButtonUrl } from "../../v2_actions/nav";
import { useEventsPageStartupEffects } from "../hooks/useEventsPageStartupEffects";
import { useIsMobile } from "../../actions/ui";
import { useParams } from "react-router-dom";

export const EventPage = () => {
  setGalleryNavBackButtonUrl();
  const isMobile = useIsMobile();
  const isInIframe = isWindowInIframe();
  const { gallery_event_name } = useParams();
  const { publicUrlPathForGalleryEvent } = useParams();
  const galleryEventNameForAPI = replaceDashesWithSpaces(gallery_event_name);
  const galleryEventNameForURL = formatSessionNameForURL(gallery_event_name);

  useEventsPageStartupEffects();

  useEffect(() => {
    if (gallery_event_name) {
      ReactGA.event({
        category: "Events/Schools",
        label: `${gallery_event_name}`,
        action: "Entered an events/school page",
      });
    }
    return () => {
      if (gallery_event_name) {
        ReactGA.event({
          category: "Events/Schools",
          label: `${gallery_event_name}`,
          action: "Exited an events/school page",
        });
      }
    };
  }, [gallery_event_name]);

  return (
    <EventsLayout activeTab="events" isInIframe={isInIframe}>
      <Box
        sx={{ margin: "auto", flexGrow: 1, width: "95%" }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ paddingTop: "3rem !important"  }}>
            <DesktopEventList
              gallery_event_name={galleryEventNameForAPI}
            />
          </Grid>
        </Grid>
      </Box>
    </EventsLayout>
  );
};
